import React, { useState } from 'react';
import { Unstable_NumberInput as BaseNumberInput } from '@mui/base/Unstable_NumberInput';
import { Box, TextField } from '@mui/material';
import { styled, width } from '@mui/system';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { Input } from '@mui/material';

const CustomNumberInput = ({
  id,
  label,
  minimo,
  maximo,
  error,
  helperText,
  value,
  onChange,
  incrementsButtons = false,
  symbol = false,
  labelText,
  line = true,
  disabled = false,
  width,
  ...props
}) => {
  return (<>
    <Box display='flex' flexDirection={line ? 'row' : 'column'} alignItems={line ? 'center' : 'flex-start'} width={width}>
      <label>{labelText}</label>
      <BaseNumberInput
        startAdornment={symbol &&
          <Box>
            <svg
              // From Feather: https://feathericons.com/?query=dollar-sign
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="1" x2="12" y2="23" />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </Box >

        }
        slots={{
          root: StyledInputRoot,
          input: StyledInput,
          // input: (props) => (
          //   <input
          //     className='input2'
          //     {...props}
          //     //onChange={handleInputChange}
          //     style={{
          //       // Estilos personalizados para el componente de entrada
          //       fontSize: '0.875rem',
          //       fontFamily: 'inherit',
          //       fontWeight: '400',
          //       lineHeight: '1.375',
          //       color: '#9DA8B7' /* Reemplaza con el valor correcto según tu paleta de colores */,
          //       background: '#fff' /* Reemplaza con el valor correcto según tu paleta de colores */,
          //       border: '1px solid #DAE2ED' /* Reemplaza con el valor correcto según tu paleta de colores */,
          //       boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
          //       borderRadius: '8px',
          //       margin: '0 8px',
          //       padding: '10px 12px',
          //       outline: '0',
          //       minWidth: '0',
          //       width: '100%;',
          //       textAlign: 'center'
          //     }}
          //   />
          // ),
          incrementButton: incrementsButtons ? StyledButton : () => { },
          decrementButton: incrementsButtons ? StyledButton : () => { },
        }}
        slotProps={{
          incrementButton: {
            children: <AddIcon fontSize="small" />,
            className: 'increment',
          },
          decrementButton: {
            children: <RemoveIcon fontSize="small" />,
          },
        }}
        id={id}
        //onInputChange={onChange}
        label={label}
        error={error}
        helperText={helperText}
        value={value}
        onChange={onChange}
        min={minimo}
        max={maximo}
        {...props}
        disabled={disabled}
      //ref={ref}
      />
    </Box>
  </>
  );
}

export default CustomNumberInput;

const InputAdornment = styled('div')(
  ({ theme }) => `
  margin: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  grid-row: 1/3;
  color: ${theme.palette.mode === 'dark' ? grey[500] : grey[700]};
`,
);

const blue = {
  100: '#daecff',
  200: '#b6daff',
  300: '#66b2ff',
  400: '#3399ff',
  500: '#007fff',
  600: '#0072e5',
  700: '#0059B2',
  800: '#004c99',
};

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const StyledInputRoot = styled('div')(
  ({ theme }) => `
  font-family: IBM Plex Sans, sans-serif;
  font-weight: 400;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`,
);

const StyledInput = styled('input')(
  ({ theme }) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.375;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
  border-radius: 8px;
  margin: 0 8px;
  padding: 10px 12px;
  outline: 0;
  min-width: 0;
  width: 80%;
  text-align: center;

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
  }

  &:focus-visible {
    outline: 0;
  }
`,
);

const StyledButton = styled('button')(
  ({ theme }) => `
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 999px;
  border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  width: 32px;
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
    border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
    color: ${grey[50]};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`,
);
